<template>
	<j-expendable-box class="bg5 b1 bc7 r2">
		<div
			slot="header"
			class="pl3 pr3 pt4 pb4 lh125 fs4 c1 fw7"
		>{{ $t("clauses") }}</div>
		<div class="bt1 bc7 p4" slot="body">
			<clauses-for-offer
				:caseId="$store.state.caseManagement.caseId"
				:proposalId="$store.state.caseManagement.proposalId"
				:offerId="$store.state.caseManagement.offerId"
			/>
		</div>
	</j-expendable-box>
</template>

<script>
import JExpendableBox from "@/components/JExpendableBox"

import ClausesForOffer from "@/modules/core/components/CoreClausesCard/ClausesForOffer"

export default {
	components: { JExpendableBox, ClausesForOffer }
}
</script>
